export const data = {


    scene: '03_apv_taustoitus',
    kysymysteksti: 'Elna kertoo, että Pentti oli hakenut apuvälinelainaamosta joitakin apuvälineitä koska on menossa siihen tekonivelleikkaukseen. Olivat siellä lainaamossa ilmeisesti opettaneet niiden käytönkin, mutta ei se Pena meinaa muistaa yhtään. Ryhdyt opastamaan apuvälineiden käyttöä Pentille ja Elnalle.',

    optiot: []


};